// src/components/ContactFormSection.jsx
import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';

function ContactFormSection({ prefilledSubject }) { // 1. Recibe la prop
  const form = useRef();
  const [notification, setNotification] = useState(null);

  // 2. Añade un estado para los datos del formulario
  const [formData, setFormData] = useState({
    from_name: '',
    reply_to: '',
    subject: prefilledSubject || '', // 3. Usa la prop para inicializar el asunto
    message: ''
  });

  // 4. Efecto para actualizar el asunto si la prop cambia (ej: si el usuario navega y vuelve)
  useEffect(() => {
    if (prefilledSubject) {
      setFormData(prevState => ({
        ...prevState,
        subject: prefilledSubject
      }));
    }
  }, [prefilledSubject]);

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => setNotification(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const sendEmail = (e) => {
    e.preventDefault();
    console.log("Intentando enviar el formulario...");
    
    // emailjs.sendForm sigue funcionando porque lee los valores actualizados del DOM
    emailjs.sendForm('service_roazv1r', 'template_hl27huw', form.current, '23bh4vJCRzng0cTTl')
      .then((result) => {
          console.log('SUCCESS!', result.text);
          setNotification({ type: 'success', text: '¡Mensaje enviado con éxito!' });
          form.current.reset();
          // Reseteamos el estado local también
          setFormData({ from_name: '', reply_to: '', subject: '', message: '' });
      }, (error) => {
          console.log('FAILED...', error.text);
          setNotification({ type: 'error', text: 'Hubo un error al enviar el mensaje. Inténtalo de nuevo.' });
      });
  };

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <h1 className="display-6 mb-5">Si tienes alguna Consulta, Contactanos</h1>
            <p className="mb-4">
              Nuestro equipo estará encantado de ayudarte y responder tus preguntas a la brevedad posible. Completa el formulario y nos pondremos en contacto contigo.
            </p>
            
            {notification && (
              <div className={`alert ${notification.type === 'success' ? 'alert-success' : 'alert-danger'} alert-dismissible fade show`} role="alert">
                {notification.text}
                <button type="button" className="btn-close" onClick={() => setNotification(null)}></button>
              </div>
            )}

            <form ref={form} onSubmit={sendEmail}>
                <div className="row g-3">
                <div className="col-md-6">
                    <div className="form-floating">
                    <input 
                        type="text" 
                        className="form-control" 
                        id="name" 
                        name="from_name"
                        placeholder="Your Name"
                        value={formData.from_name} // 5. Conecta el valor al estado
                        onChange={handleChange} // 6. Conecta el cambio al estado
                        required
                    />
                    <label htmlFor="name">Nombre</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating">
                    <input 
                        type="email" 
                        className="form-control" 
                        id="email" 
                        name="reply_to"
                        placeholder="Your Email"
                        value={formData.reply_to}
                        onChange={handleChange}
                        required
                    />
                    <label htmlFor="email">Email</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-floating">
                    <input 
                        type="text" 
                        className="form-control" 
                        id="subject" 
                        name="subject"
                        placeholder="Subject"
                        value={formData.subject} // 7. Este campo ahora se rellenará automáticamente
                        onChange={handleChange}
                        required
                    />
                    <label htmlFor="subject">Asunto</label>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-floating">
                    <textarea 
                        className="form-control" 
                        placeholder="Leave a message here" 
                        id="message"
                        name="message"
                        style={{height: '150px'}}
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>
                    <label htmlFor="message">Mensaje</label>
                    </div>
                </div>
                <div className="col-12">
                    <button className="btn btn-primary py-3 px-5" type="submit">Enviar Mensaje</button>
                </div>
                </div>
            </form>
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s" style={{minHeight: '450px'}}>
            <div className="position-relative overflow-hidden h-100">
              <iframe 
                className="position-relative w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.91008017216!2d-70.6202385235771!3d-33.42558859624073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf63c7234f59%3A0x554ca7069c7a7ccc!2sAntonio%20Bellet%20193%2C%207500000%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses!2scl!4v1761686722607!5m2!1ses!2scl"
                frameBorder="0" 
                style={{minHeight: '450px', border:0}} 
                allowFullScreen="" 
                aria-hidden="false"
                tabIndex="0"
                title="Google Maps Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactFormSection;